import React from "react";

const Java_exp = () => {
  return (
    <div>
      <h1>Java exp</h1>
      <p>This page provides explanations, examples, and common use-cases for Java exp in Java.</p>
    </div>
  );
};

export default Java_exp;
